// extracted by mini-css-extract-plugin
export var accordionCheckbox = "product-accordion-module--accordion-checkbox--m6MMr";
export var accordionContainer = "product-accordion-module--accordion-container--266Ju";
export var accordionContent = "product-accordion-module--accordion-content--HvTAe";
export var accordionLabel = "product-accordion-module--accordion-label--ZWWJP";
export var close = "product-accordion-module--close--+QJfI";